import React, { memo } from 'react';
import { View, TouchableOpacity, FlatList } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  Text,
  Space,
  Icon,
  IconCheckBoxEmpty,
  IconCheckBoxFill,
} from '@redlink/components/atoms';

export const SelectableLinks = memo(
  ({ links, selectedLinks, onSelectItem }) => {
    return (
      <FlatList
        keyExtractor={({ id }) => `${id}`}
        data={links}
        ItemSeparatorComponent={() => <Space size={8} />}
        renderItem={({ item }) => (
          <SelectableLinkItem
            onPress={() => onSelectItem(item)}
            {...{ item }}
            isSelected={selectedLinks.indexOf(item.id) === -1 ? false : true}
          />
        )}
        showsVerticalScrollIndicator={false}
      />
    );
  }
);

export const SelectableLinkItem = memo(
  ({ item: { title, logoName }, isSelected, onPress }) => {
    const { styles, colors } = useStyle();
    return (
      <TouchableOpacity
        activeOpacity={0.7}
        {...{ onPress }}
        style={[
          styles.itemContainer,
          isSelected && styles.selectedItemContainer,
        ]}
      >
        <View style={styles.itemContentContainer}>
          <Icon
            name={logoName}
            color={isSelected ? colors.blue1 : colors.gray23}
          />
          <Text
            style={[styles.itemText, isSelected && styles.selectedItemText]}
          >
            {title}
          </Text>
        </View>
        {isSelected ? (
          <IconCheckBoxFill color={colors.blue1} />
        ) : (
          <IconCheckBoxEmpty color={colors.gray21} />
        )}
      </TouchableOpacity>
    );
  }
);

const useStyle = createUseStyle(({ colors }) => ({
  itemContainer: {
    padding: 8,
    height: 40,
    borderRadius: 10,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.gray7,
  },
  selectedItemContainer: {
    backgroundColor: colors.blue8,
  },
  itemContentContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemText: {
    fontSize: 15,
    lineHeight: 17,
    fontWeight: '500',
    marginHorizontal: 8,
    color: colors.black,
  },
  selectedItemText: {
    color: colors.blue1,
  },
}));
